<template>
  <div style="display: inline-block">
    <div
      v-if="channels.facebook"
      class="channel-tab py-1 pl-2 pr-2"
      :class="{ 'primary white--text': tab == 'facebook' || tab == 'fb' }"
      @click="$emit('onChange', 'facebook')"
    >
      <span class="fab fa-facebook"></span>
    </div>
    <div
      v-if="channels.line"
      :class="{ 'primary white--text': tab == 'line' }"
      @click="$emit('onChange', 'line')"
      class="channel-tab py-1 pl-2 pr-2"
    >
      <span class="fab fa-line"></span>
    </div>
    <div
      v-if="channels.instagram"
      :class="{ 'primary white--text': tab == 'instagram' }"
      @click="$emit('onChange', 'instagram')"
      class="channel-tab py-1 pl-2 pr-2"
    >
      <span class="fab fa-instagram"></span>
    </div>
    <div
      v-if="channels.google"
      :class="{ 'primary white--text': tab == 'google' }"
      @click="$emit('onChange', 'google')"
      class="channel-tab py-1 pl-2 pr-2"
    >
      <span class="fab fa-google"></span>
    </div>
    <div
      v-if="channels.whatsapp"
      :class="{ 'primary white--text': tab == 'whatsapp' }"
      @click="$emit('onChange', 'whatsapp')"
      class="channel-tab py-1 pl-2 pr-2"
    >
      <span class="fab fa-whatsapp"></span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: ['tab'],
  data() {
    return {
      channels: {
        facebook: false,
        line: false,
        instagram: false,
        google: false,
        whatsapp: false,
      }
    }
  },
  mounted() {
    const { packages } = this.selectedBot

    _(this.channels).keys().each((key) => {
      this.channels[key] = packages.includes(key)
    })
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
  }
}
</script>

<style lang="scss" scoped>
.channel-tab {
  border: 1px solid #eee;
  border-width: 1px 0px 1px 1px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/ChannelTab.vue